import arrowleft from "@Images/NewUI/Vector.png";
import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import { HEADING_POLICIES } from "../Common/constant";

const NewPolicies = (props) => {
  const redirectUrl = (url) => {
    window.open(url, "_blank");
  };

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="main_div_whiteBackground">
      {isLargeScreen && (
        <div
          style={{ paddingBottom: "18px" }}
          className="customheading minwid320 shadowline sticky-header"
        >
          <img
            style={{ cursor: "pointer", marginLeft: "20px" }}
            className="customimgfix"
            src={arrowleft}
            onClick={() => {
              window.location.href = "/profile_menu";
            }}
          />
          <span
            style={{
              paddingLeft: "18px",
              color: "#152745",
              fontWeight: "700",
              fontSize: "30px",
            }}
          >
            {HEADING_POLICIES}
          </span>
        </div>
      )}

{!isLargeScreen && (
            <div
              style={{ paddingBottom: "18px" }}
              className="customheading maxWidth450 minwid320 shadowline sticky-header pt-2 pb-5"
            >
              <img
                style={{ cursor: "pointer", marginLeft: "30px" }}
                className="customimgfix"
                src={arrowleft}
                onClick={() => {
                  window.location.href = "/profile_menu";
                }}
              />
              <span
                style={{
                  paddingLeft: "27px",
                  color: "rgb(21, 39, 69)",
                  fontWeight: "800",
                  fontSize: "25px",
                }}
              >
                {HEADING_POLICIES}
              </span>
            </div>
          )}

      <div className={`pb-4 ${isLargeScreen ? "toolbarRespo" : "toolbarResponew"} `}>

        <div className="alignleftt">
        

          <div className="profile_lower_sc paddingpolicies">
            <ul>
              <li onClick={() => redirectUrl(process.env.REACT_APP_PRIVACY_POLICY)}>Privacy Policy</li>
              <li onClick={() => redirectUrl(process.env.REACT_APP_REFUND_POLICY)}>Refund Policy</li>
              <li onClick={() => redirectUrl(process.env.REACT_APP_T_C)}>T&C</li>
              <li onClick={() => redirectUrl(process.env.REACT_APP_FAIR_PRACTICE_CODE)}>Fair Practice Code</li>
              <li onClick={() => redirectUrl(process.env.REACT_APP_DISCLAMER)}>Disclaimer</li>
              <span className="jkafdjk"></span>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPolicies;
